var _a;
export var SituacaoProcessoEnum;
(function (SituacaoProcessoEnum) {
    SituacaoProcessoEnum["RASCUNHO"] = "RASCUNHO";
    SituacaoProcessoEnum["PENDENTE"] = "PENDENTE";
    SituacaoProcessoEnum["AGUARDANDO_ANALISE"] = "AGUARDANDO_ANALISE";
    SituacaoProcessoEnum["APROVADO"] = "APROVADO";
    SituacaoProcessoEnum["REPROVADO"] = "REPROVADO";
    SituacaoProcessoEnum["VENCIDO"] = "VENCIDO";
})(SituacaoProcessoEnum || (SituacaoProcessoEnum = {}));
export var SituacaoProcessoLabels = [
    { label: 'Rascunho', value: SituacaoProcessoEnum.RASCUNHO },
    {
        label: 'Pendente - Aguardando Complementação',
        value: SituacaoProcessoEnum.PENDENTE,
    },
    {
        label: 'Aguardando Análise',
        value: SituacaoProcessoEnum.AGUARDANDO_ANALISE,
    },
    { label: 'Aprovado', value: SituacaoProcessoEnum.APROVADO },
    { label: 'Reprovado', value: SituacaoProcessoEnum.REPROVADO },
    { label: 'Vencido', value: SituacaoProcessoEnum.VENCIDO },
];
export var SituacaoProcessoStatusIndicator = (_a = {},
    _a[SituacaoProcessoEnum.RASCUNHO] = {
        status: 'warning',
        message: 'Em rascunho',
    },
    _a[SituacaoProcessoEnum.PENDENTE] = {
        status: 'warning',
        message: 'Pendente - Aguardando Complementação',
    },
    _a[SituacaoProcessoEnum.AGUARDANDO_ANALISE] = {
        status: 'info',
        message: 'Aguardando Análise',
    },
    _a[SituacaoProcessoEnum.APROVADO] = {
        status: 'success',
        message: 'Aprovado',
    },
    _a[SituacaoProcessoEnum.REPROVADO] = {
        status: 'error',
        message: 'Reprovado',
    },
    _a[SituacaoProcessoEnum.VENCIDO] = {
        status: 'error',
        message: 'Vencido',
    },
    _a);
